import { SVG } from './esveegee.js'

import { Colors } from './colors.js'

type ColorPredicate = (rank: number, file: number) => boolean

const board = (svg: SVG, characters: string[], colorPredicate: ColorPredicate) => {
    // TODO this is a viewBox (which might be a good idea)
    const [width, height] = [100, 100]

    const padding = Math.max(width, height) / 16

    const [rows, columns] = [characters[0].length, characters.length]
    const cellSize = { width: ~~(width / (columns + 1)), height: ~~(height / (rows + 1)) }

    const board = svg.group(padding, padding)
    const ranks = svg.group(cellSize.width / 4, cellSize.height)
    const files = svg.group(padding + cellSize.width / 2, (rows + 1) * cellSize.height)

    const pieces = svg.group(padding + cellSize.width / 2, padding + cellSize.height / 2)

    for (const [rank, row] of characters.entries()) {
        for (const [file, character] of row.split('').entries()) {

            const [x, y] = [file * cellSize.width, rank * cellSize.height]

            // tile
            const fill = (rank ^ file) % 2 ? Colors.SeaBlue : Colors.SeaBlueLight
            board.rect(x, y, cellSize.width, cellSize.height)
                .stroke().fill(fill)

            // piece
            if (character !== ' ') {
                pieces.text(character, x, y)
                    .fill(colorPredicate(rank, file) ? 'white' : 'black')
                    .size(cellSize.height * 3 / 4)
                    .align('middle')
                    .verticalAlign('middle')
                    .draggable()
            }
        }

        // ranks
        ranks.text((rows - rank).toString(),
            0, rank * cellSize.height)
            .fill(Colors.Text)
            .align('middle')
            .verticalAlign('middle')

        // files
        files.text(String.fromCharCode(rank + 97), rank * cellSize.width, 0)
            .fill(Colors.Text)
            .align('middle')

    }
}

export const ataxx = (svg: SVG) => {
    const characters = [
        '⬤     ⬤',
        '       ',
        '       ',
        '       ',
        '       ',
        '       ',
        '⬤     ⬤',
    ]

    const piececolorer = (rank: number, file: number) => rank === 0 && file === 0 || rank === 6 && file === 6
    board(svg, characters, piececolorer)
}

export const chess = (svg: SVG) => {

    // TODO doesn't work, crashes even (without errors in the console), probably because of svg.size() being void
    // const { ...dimensions } = svg.size()
    // console.log(dimensions)

    const size = () => ({ width: 1, height: 2 })
    const { ...dimensions } = size()


    const characters = [
        '♜♞♝♛♚♝♞♜',
        '♟♟♟♟♟♟♟♟',
        '        ',
        '        ',
        '        ',
        '        ',
        '♟♟♟♟♟♟♟♟',
        '♜♞♝♛♚♝♞♜',
    ]

    const piececolorer = (rank: number,) => rank > 3
    board(svg, characters, piececolorer)
}
